import React from 'react'
import RoutedWizard from 'core/routing/routed-wizard'
import { CONFIGURATOR } from 'core/routing/constants'
import Configurator from '.'

const router = <RoutedWizard path={CONFIGURATOR}>{Configurator}</RoutedWizard>

export default router
